var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5021 6.44318C24.3607 5.91132 24.0822 5.42591 23.6943 5.03553C23.3064 4.64515 22.8228 4.3635 22.2918 4.21875C20.3373 3.69318 12.5248 3.69318 12.5248 3.69318C12.5248 3.69318 4.71228 3.69318 2.75773 4.21875C2.22679 4.3635 1.74318 4.64515 1.35529 5.03553C0.967401 5.42591 0.688849 5.91132 0.547508 6.44318C0.0247803 8.40625 0.0247803 12.5 0.0247803 12.5C0.0247803 12.5 0.0247803 16.5938 0.547508 18.5568C0.688849 19.0887 0.967401 19.5741 1.35529 19.9645C1.74318 20.3548 2.22679 20.6365 2.75773 20.7813C4.71228 21.3068 12.5248 21.3068 12.5248 21.3068C12.5248 21.3068 20.3373 21.3068 22.2918 20.7813C22.8228 20.6365 23.3064 20.3548 23.6943 19.9645C24.0822 19.5741 24.3607 19.0887 24.5021 18.5568C25.0248 16.5938 25.0248 12.5 25.0248 12.5C25.0248 12.5 25.0248 8.40625 24.5021 6.44318Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96799 16.2174V8.78271L16.5021 12.5L9.96799 16.2174Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.075b87e21d102effe7bf85dcd0bf5079.svg";
export { ForwardRef as ReactComponent };